import type { RecentSearch } from 'src/sections/search/types/recent-search';
import { parseQParam } from 'src/sections/search/utils/filter-utils';

/**
 * Extracts unique repo slugs from recent search queries, preserving recency order.
 *
 * Iterates through `recentSearches` (assumed sorted by recency, most recent first)
 * and uses the query parser to extract `repo:` filter values. Collects unique slugs
 * into a Set for deduplication.
 *
 * Both `repo:` and `repository:` filter syntax are recognised — the parser
 * normalises them to the same attribute internally.
 *
 * Returns an empty array when no recent searches contain repo filters.
 */
export function extractRepoSlugsFromRecentSearches(
  recentSearches: RecentSearch[]
): string[] {
  const slugs = new Set<string>();

  for (const search of recentSearches) {
    const { filterState } = parseQParam(search.query);
    filterState.repo.filter(repo => repo).forEach(repo => slugs.add(repo));
  }

  return [...slugs];
}
